import { useEffect } from 'react';
import { X, Download } from 'lucide-react';

export function ImageLightbox({ src, title, onClose, downloadName }) {
  useEffect(() => {
    if (!src) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = ''; };
  }, [src, onClose]);

  if (!src) return null;

  return (
    <div
      data-testid="image-lightbox"
      onClick={onClose}
      className="fixed inset-0 z-[200] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in duration-150"
    >
      <div className="absolute top-4 right-4 flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
        <a
          data-testid="lightbox-download"
          href={src}
          download={downloadName || 'frame.jpg'}
          className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors"
          title="Download full-size"
        >
          <Download className="w-5 h-5" />
        </a>
        <button
          data-testid="lightbox-close"
          onClick={onClose}
          className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors"
          title="Close (Esc)"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
      {title && (
        <span className="absolute top-6 left-6 text-sm text-white/70 font-medium">{title}</span>
      )}
      <img
        src={src}
        alt={title || 'Frame'}
        onClick={(e) => e.stopPropagation()}
        className="max-w-[95vw] max-h-[90vh] object-contain rounded-lg shadow-2xl"
      />
      <span className="absolute bottom-5 left-1/2 -translate-x-1/2 text-xs text-white/40">Click anywhere or press Esc to close</span>
    </div>
  );
}
